define([], function(){

    function AbstractMediaStorage() {}

    var c = AbstractMediaStorage;
    var p = c.prototype;

    p.setManifestLoaded = function(manifest)
    {
        var str = _getManifestString_(manifest);
        this._manifests = this._manifests || {};
        this._manifests[str] = true;

        return manifest;
    }

    p.isManifestLoaded = function(manifest)
    {
        var str = _getManifestString_(manifest);
        return Boolean(this._manifests && this._manifests[str]);
    }

    p.getManifestIdentifier = function(manifest)
    {
        return _getManifestString_(manifest);
    }

    function _getManifestString_(manifest)
    {
        if (typeof manifest === "undefined") return "undefined";
        if (!manifest) return manifest;
        if (typeof manifest === "string") return '"' + manifest + '"';
        if (typeof manifest !== "object") return manifest.toString();

        let s = "";
        if (typeof manifest.shift === "function")
        {
            s += "[";
            let i;
            for (i = 0; i < manifest.length; i++)
            {
                s += _getManifestString_(manifest[i]) + ',';
            }
            s += "]";
        }
        else
        {
            s += "{";

            let key = "id";
            if (manifest.hasOwnProperty(key))
            {
                s += key + ':';
                s += _getManifestString_(manifest[key]) + ',';
            }
            key = "src";
            if (manifest.hasOwnProperty(key))
            {
                s += key + ':';
                s += _getManifestString_(manifest[key]) + ',';
            }

            s += "}";
        }
        return s;
    }

    // HTML
    p.addHTML = function(id, json)
    {
        this._htmls = this._htmls || {};
        this._htmls[id] = json;

        return json;
    }

    p.setHTMLNotLoaded = function(id)
    {
        this._htmls = this._htmls || {};
        if (typeof this._htmls[id] !== "undefined") return this._htmls[id];
        this._htmls[id] = null;
    }

    p.getHTML = function(id)
    {
        if (!this._htmls) return undefined;
        return this._htmls[id];
    }

    p.clearHTML = function(id)
    {
        delete this._htmls[id];
    }

    // JSON
    p.addJSON = function(id, json)
    {
        this._json = this._json || {};
        this._json[id] = json;

        return json;
    }

    p.setJSONNotLoaded = function(id)
    {
        this._json = this._json || {};
        if (typeof this._json[id] !== "undefined") return this._json[id];
        this._json[id] = null;
    }

    p.getJSON = function(id)
    {
        if (!this._json) return undefined;
        return this._json[id];
    }

    // IMAGES
    p.addImageLoaded = function(item, image)
    {
        this._images = this._images || {};
        this._imageStore = this._imageStore || {};
        this._images[item.id] = {item: item, id: item.id, src: item.src, width: item.width, height: item.height};
        this._imageStore[item.id] = image;

        return item;
    }

    p.setImageNotLoaded = function(item)
    {
        this._images = this._images || {};
        this._imageStore = this._imageStore || {};
        this._images[item.id] = null;
        this._imageStore[item.id] = null;
        return item;
    }

    p.getImageItemById = function(id)
    {
        if (!this._images || typeof this._images[id] === "undefined") return null;
        return this._images[id];
    }

    p.getImageById = function(id)
    {
        if (!this._imageStore || typeof this._imageStore[id] === "undefined") return null;
        return this._imageStore[id];
    }

    p.getImagesLoaded = function()
    {
        return this._images;
    }

    p.getImagesStorage = function()
    {
        return this._imageStore;
    }

    // Spritesheet
    p.addSpritesheetLoaded = function(item, ssht)
    {
        this._sshts = this._sshts || {};
        this._sshtStore = this._sshtStore || {};
        this._sshts[item.id] = {item: item, id: item.id, src: item.src, width: item.width, height: item.height};
        this._sshtStore[item.id] = ssht;

        return item;
    }

    p.setSpritesheetNotLoaded = function(item)
    {
        this._sshts = this._sshts || {};
        this._sshtStore = this._sshtStore || {};
        this._sshts[item.id] = null;
        this._sshtStore[item.id] = null;
        return item;
    }

    p.getSpritesheetItemById = function(id)
    {
        if (!this._sshts || typeof this._sshts[id] === "undefined") return null;
        return this._sshts[id];
    }

    p.getSpritesheetById = function(id)
    {
        if (!this._sshtStore || typeof this._sshtStore[id] === "undefined") return null;
        return this._sshtStore[id];
    }

    p.getSpritesheetsLoaded = function()
    {
        return this._sshts;
    }

    p.getSpritesheetsStorage = function()
    {
        return this._sshtStore;
    }

    // SVG
    p.addSVGLoaded = function(item, svg)
    {
        this._svgs = this._svgs || {};
        this._svgStore = this._svgStore || {};
        this._svgs[item.id] = {item: item, id: item.id, src: item.src, width: item.width, height: item.height};
        this._svgStore[item.id] = svg;
        return item;
    }

    p.setSVGNotLoaded = function(item)
    {
        this._svgs = this._svgs || {};
        this._svgStore = this._svgStore || {};
        this._svgs[item.id] = null;
        this._svgStore[item.id] = null;
        return item;
    }

    p.getSVGItemById = function(id)
    {
        if (!this._svgs || typeof this._svgs[id] === "undefined") return null;
        return this._svgs[id];
    }

    p.getSVGById = function(id)
    {
        if (!this._svgStore || typeof this._svgStore[id] === "undefined") return null;
        return this._svgStore[id];
    }

    p.getSVGsLoaded = function()
    {
        return this._svgs;
    }

    p.getSVGsStorage = function()
    {
        return this._svgStore;
    }

    p.reset = function()
    {
        if (this._json) delete this._json;
        if (this._htmls) delete this._htmls;
        if (this._images) delete this._images;
        if (this._sshts) delete this._sshts;
        if (this._svgs) delete this._svgs;
    }

    return c;
});




// WEBPACK FOOTER //
// ./js/rrjs/base/commands/load/assist/AbstractMediaStorage.js